import * as download from "downloadjs"


export const downloadFile = async (responsePromise) => {
    const response = await responsePromise
    if (response.status === 200) {
        const escapeQuotesRegExp = new RegExp('"', 'g');

        const fileName = decodeURIComponent(/filename\*?=([^']*'')?([^;]*)/.exec(response.headers["content-disposition"])[2]).replace(escapeQuotesRegExp, '')
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type})

        download(blob,
            fileName,
            type)
    }
}
